package ru.villawonka.app.platform.telegram.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * This object contains the data of the Mini App user.
 * @property id A unique identifier for the user or bot.
 * This number may have more than 32 significant
 * bits and some programming languages may have
 * difficulty/silent defects in interpreting it.
 * It has at most 52 significant bits, so a 64-bit
 * integer or a double-precision float type is safe
 * for storing this identifier.
 * @property isBot True, if this user is a bot. Returns in the receiver field only.
 * @property firstName First name of the user or bot.
 * @property lastName Last name of the user or bot.
 * @property languageCode IETF language tag of the user's language. Returns in user field only.
 * @property isPremium True, if this user is a Telegram Premium user.
 * @property addedToAttachmentMenu True, if this user added the bot to the attachment menu.
 * @property allowsWriteToPm True, if this user allowed the bot to message them.
 * @property photoUrl URL of the user’s profile photo. The photo can be in .jpeg or .svg formats.
 */
@Serializable
data class WebAppUser(
    @SerialName("id")
    val id: Long,
    @SerialName("is_bot")
    val isBot: Boolean? = null,
    @SerialName("first_name")
    val firstName: String,
    @SerialName("last_name")
    val lastName: String? = null,
    @SerialName("username")
    val username: String? = null,
    @SerialName("language_code")
    val languageCode: String? = null,
    @SerialName("is_premium")
    val isPremium: Boolean? = null,
    @SerialName("added_to_attachment_menu")
    val addedToAttachmentMenu: Boolean? = null,
    @SerialName("allows_write_to_pm")
    val allowsWriteToPm: Boolean? = null,
    @SerialName("photo_url")
    val photoUrl: String? = null
)